/**
 * Canonical HTML-comment marker format used by the engine to wrap
 * Liquid outputs that the editor can patch in-place.
 *
 *   <!--lc:setting:section.<id>.<name>-->value<!--/lc:setting:section.<id>.<name>-->
 *
 * Keep this in sync with `lc-store-engine/src/renderer/marker-injector.ts`.
 */

export const MARKER_PREFIX = 'lc:setting:';
export const MARKER_PREFIX_END = '/lc:setting:';

export function beginMarker(ref: string): string {
  return `${MARKER_PREFIX}${ref}`;
}
export function endMarker(ref: string): string {
  return `${MARKER_PREFIX_END}${ref}`;
}

export function sectionSettingRef(sectionId: string, settingId: string): string {
  return `section.${sectionId}.${settingId}`;
}
export function blockSettingRef(blockId: string, settingId: string): string {
  return `block.${blockId}.${settingId}`;
}
